export default "__VITE_ASSET__DvNkjhRM__"